import React, { useContext, useEffect, useRef, useState } from "react";
import Add from "../../../Assets/Icons/Add icon.svg";
import Edit from "../../../Assets/Icons/edit.svg";
import Delete from "../../../Assets/Icons/delete.svg";
import { message, Modal, Select } from "antd";
import CommonFunctions from "../../Shared/CommonFunctions";
import DrugServices from "../../../Services/DrugServices";
import { RxCross2 } from "react-icons/rx";
import { VoiceCommandContext } from "../VoiceCommand/VoiceContext";
import { FaRegStar } from "react-icons/fa";

function Medicine({
  appointmentDetails,
  drugPrescription,
  setDrugPrescription,
  suggestiveData,
  selectedSymObj,
}) {
  let loginData = sessionStorage.getItem("login_result");
  let loginDataObject = loginData ? JSON.parse(loginData) : null;
  const [medicineList, setMedicineList] = useState([]);
  const [formData, setFormData] = useState({
    medicineName: "",
    composition: "",
    dosage: "",
    duration: "",
    quantity: "",
    timeTaken: "",
    notes: "",
    frequency: "",
  });
  const [selectedMed, setSelectedMed] = useState({});
  const [suggestiveMedList, setSuggestiveMedList] = useState([]);
  const fromSuggestionClick = useRef(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (fromSuggestionClick.current && selectedMed) {
      onMedicineSave(selectedMed);
      fromSuggestionClick.current = false;
    }
  }, [selectedMed]);

  useEffect(() => {
    setSuggestiveMedList(suggestiveData);
  }, [suggestiveData]);

  const {
    medicineData,
    setMedicineData,
    medicineVoice,
    setMedicineVoice,
    deleteMedicineVoice,
    setDeleteMedicineVoice,
    editMedicineVoice,
    setEditMedicineVoice,
    selectAllVoice,
    setSelectAllVoice,
  } = useContext(VoiceCommandContext);

  useEffect(() => {
    if (!deleteMedicineVoice) return;

    const lowerVoice = deleteMedicineVoice.toLowerCase();

    const matchedDrug = drugPrescription.find((drug) =>
      drug?.drugName?.toLowerCase().includes(lowerVoice)
    );

    if (matchedDrug) {
      handleDelete(matchedDrug);
      message.success(`Deleted medicine: ${matchedDrug.drugName}`);
    } else {
      message.error(`No matching medicine found: "${deleteMedicineVoice}"`);
    }

    setDeleteMedicineVoice(""); // Clear after processing
  }, [deleteMedicineVoice]);

  useEffect(() => {
    if (!medicineVoice) return;

    const fetchAndSet = async () => {
      await onSearchMedicine(medicineVoice);

      setTimeout(() => {
        const matched = medicineList.find((item) =>
          item.medicineName.toLowerCase().includes(medicineVoice.toLowerCase())
        );

        if (matched) {
          handleSelectedMedicine(matched);
          message.success(`Auto-selected: ${matched.medicineName}`);
        } else {
          // Voice gave new medicine name
          setFormData((prev) => ({
            ...prev,
            medicineName: medicineVoice,
            composition: prev.composition || "", // preserve existing composition
          }));
          message.info(`Typed medicine: ${medicineVoice}`);
        }

        setMedicineVoice("");
      }, 500);
    };

    fetchAndSet();
  }, [medicineVoice, medicineList]);

  useEffect(() => {
    if (selectAllVoice.toLowerCase().includes("select all medicine")) {
      handleSelAllMed(); // your existing function
      message.success("✅ All suggested medicines selected");
      setSelectAllVoice(""); // reset after use
    }
  }, [selectAllVoice]);

  useEffect(() => {
    if (medicineData.medicineName) {
      setFormData((prev) => ({
        ...prev,
        medicineName: medicineData.medicineName,
        composition: medicineData.composition,
      }));
    }
  }, [medicineData]);

  useEffect(() => {
    if (medicineData.composition) {
      setFormData((prev) => ({
        ...prev,
        composition: medicineData.composition,
      }));
    }
  }, [medicineData.composition]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      dosage: medicineData.dosage || prev.dosage,
      duration: medicineData.duration || prev.duration,
      frequency: medicineData.frequency || prev.frequency,
      quantity: medicineData.quantity || prev.quantity,
      timeTaken: medicineData.timeTaken || prev.timeTaken,
      notes: medicineData.notes || prev.notes,
    }));
  }, [
    medicineData.dosage,
    medicineData.duration,
    medicineData.frequency,
    medicineData.quantity,
    medicineData.timeTaken,
    medicineData.notes,
  ]);

  useEffect(() => {
    if (!editMedicineVoice) return;

    const lowerVoice = editMedicineVoice.toLowerCase();

    const matchedDrugIndex = drugPrescription.findIndex((drug) =>
      drug?.drugName?.toLowerCase().includes(lowerVoice)
    );

    if (matchedDrugIndex !== -1) {
      const matchedDrug = drugPrescription[matchedDrugIndex];
      showEditModal(matchedDrug, matchedDrugIndex);
      message.success(`Editing medicine: ${matchedDrug.drugName}`);
    } else {
      message.error(`No matching medicine found for "${editMedicineVoice}"`);
    }

    setEditMedicineVoice(""); // clear after handling
  }, [editMedicineVoice]);

  useEffect(() => {
    if (!medicineData) return;

    setEditDrugDetails((prev) => ({
      ...prev,
      medicineName: medicineData.medicineName || prev.medicineName,
      composition: medicineData.composition || prev.composition,
      dosage: medicineData.dosage || prev.dosage,
      duration: medicineData.duration || prev.duration,
      quantity: medicineData.quantity || prev.quantity,
      timeTaken: medicineData.timeTaken || prev.timeTaken,
      notes: medicineData.notes || prev.notes,
    }));
  }, [medicineData]);

  const onSearchMedicine = async (value) => {
    let payload = {
      medicineName: value,
      pageNo: 1,
      size: 40,
      userId: appointmentDetails.userId,
    };
    // dev
    if (loginDataObject.user.userId == "DZU3191271") {
      payload.pharmacyId = "DZA1361124"
    }


    // prod
    // userId : DZU6631021
    // PharmacyId : DZA1131011


    // if (loginDataObject.user.userId == "DZU6631021") {
    //   payload.pharmacyId = "DZA1131011"
    // }

    try {
      let result = await DrugServices.fetchDrugListnew(payload);
      setMedicineList(result.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelectedMedicine = (medicine) => {
    setSelectedMed(medicine);
    setMedicineList([]);
    if (isModalOpen) {
      setEditDrugDetails((prevState) => ({
        ...prevState,
        medicineName: medicine.medicineName,
        composition: medicine.saltComposition ? medicine.saltComposition : "",
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        medicineName: medicine.medicineName,
        composition: medicine.saltComposition ? medicine.saltComposition : "",
      }));
    }
  };

  const handleChange = (field, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };
  const handleClear = (field) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: "",
    }));
  };

  const options = [
    "0-0-1",
    "0-1-1",
    "0-1-0",
    "1-1-1",
    "1-0-0",
    "1-0-1",
    "1-1-0",
    "1-1-1-1",
    "1-0-0-1",
    "1-0-0-0",
    "1-1-0-0",
    "1-1-1-0",
    "0-0-0-1",
    "0-0-1-1",
    "0-0-1-0",
    "0-1-0-0",
    "0-1-1-1",
    "s.o.s",
    "q.wk.",
    "b.i.d.",
    "t.i.d.",
    "q.i.d.",
    "q.h.s.",
    "5X a day",
    "q.4h",
    "q.6h",
    "q.0.d.",
    "prn.",
    "q.d.",
    "I.M.",
    "Subq.",
    "Rectally",
    "I.V.",
    "O.D.",
    "O.S.",
    "O.U.",
    "1/2-1/2-1/2-1/2",
    "1/2-1/2-1/2",
    "3/4-3/4-3/4",
    "3/4-3/4-3/4-3/4",
    "0.5-0.5-0.5",
    "0.5-0.5-0.5-0.5",
    "0.25-0.25-0.25",
    "0.25-0.25-0.25-0.25",
    "0.75-0.75-0.75",
    "1-0.5-0.5",
    "0.5-1-0.5",
    "0.5-0-0.5",
    "1-0.5-1",
    "2 ml",
    "2.5 ml",
    "5 ml",
    "10 ml",
  ];

  const options2 = [
    "2 ml",
    "2.5 ml",
    "5 ml",
    "10 ml",
    "1/4",
    "1/2",
    "3/4",
    "1",
  ];

  const onMedicineSave = (drugItem) => {
    if (formData.medicineName == "" && formData.composition == "") {
      message.error("Enter Medicine");
      return;
    }
    let payload = {
      account_Id: appointmentDetails.account_Id,
      clinic_Id: appointmentDetails.clinic_Id,
      afterBeforeFood: formData.timeTaken,
      composition: formData.composition,
      createdBy: appointmentDetails.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      dosage: formData.dosage,
      drugCode: selectedMed?.code ? selectedMed?.code : formData?.medicineName,
      drugName: formData.medicineName,
      duration: formData.duration,
      form: null,
      frequency: formData.frequency,
      fromDateTime: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      givenDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      instruction: formData.notes,
      medicineType: null,
      modifiedBy: appointmentDetails.userId,
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      patientId: appointmentDetails.patientId,
      quantity: formData.quantity,
      specialAuthority: null,
      status: 1,
      toDateTime: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      userId: appointmentDetails.userId,
    };

    setDrugPrescription((prevData) => {
      const isAlreadyPresent = prevData.some(
        (item) => item.drugCode === payload.drugCode
      );

      if (isAlreadyPresent) {
        message.error("Medicine is already present");
        return prevData;
      } else {
        setFormData({
          medicineName: "",
          composition: "",
          dosage: "",
          duration: "",
          quantity: "",
          timeTaken: "",
          notes: "",
          frequency: "",
        });
        setMedicineData({
          medicineName: "",
          composition: "",
          dosage: "",
          duration: "",
          quantity: "",
          timeTaken: "",
          notes: "",
          frequency: "",
        });
        setSelectedMed({});
        return [...prevData, payload];
      }
    });
  };

  const saveMedicine = (drugItem) => {
    let payload = {
      account_Id: appointmentDetails.account_Id,
      clinic_Id: appointmentDetails.clinic_Id,
      afterBeforeFood: drugItem.after_Before_Food.includes("After")
        ? "AF"
        : drugItem.after_Before_Food.includes("Before")
          ? "BF"
          : "",
      composition: drugItem.composition,
      createdBy: appointmentDetails.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      dosage: drugItem.dosage,
      drugCode: drugItem.code || drugItem.medicineName,
      drugName: drugItem.medicineName,
      duration: drugItem.duration_Days,
      form: null,
      frequency: drugItem.frequency,
      fromDateTime: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      givenDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      instruction: drugItem.notes || "",
      medicineType: null,
      modifiedBy: appointmentDetails.userId,
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      patientId: appointmentDetails.patientId,
      quantity: drugItem.quantity,
      specialAuthority: null,
      status: 1,
      toDateTime: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      userId: appointmentDetails.userId,
    };

    setDrugPrescription((prevData) => {
      const isAlreadyPresent = prevData.some(
        (item) => item.drugCode === payload.drugCode
      );

      if (isAlreadyPresent) {
        message.error(`Medicine already present: ${payload.drugName}`);
        return prevData;
      }

      return [...prevData, payload];
    });
  };

  const handleDelete = (drug) => {
    if (appointmentDetails.status == 2) {
      setDrugPrescription((prevData) =>
        prevData.map((item) =>
          item.drugCode === drug.drugCode ? { ...item, status: 0 } : item
        )
      );
    } else {
      setDrugPrescription((prevData) =>
        prevData.filter((item) => item.drugCode !== drug.drugCode)
      );
    }
  };

  const handleSelectSuggMed = (drug) => {
    fromSuggestionClick.current = true;
    setSelectedMed(drug);
    setMedicineList([]);
    setFormData((prevState) => ({
      ...prevState,
      medicineName: drug.medicineName,
      composition: drug.composition ? drug.composition : "",
      dosage: drug.dosage,
      duration: drug.duration_Days,
      quantity: drug.quantity,
      timeTaken: drug.after_Before_Food.includes("After")
        ? "AF"
        : drug.after_Before_Food.includes("Before")
          ? "BF"
          : "",
    }));
    setSuggestiveMedList((prevState) => {
      if (prevState) {
        return prevState.filter((item) => item.id !== drug.id);
      }
      return prevState;
    });
  };

  const handleSuggDelete = (e, drug) => {
    e.stopPropagation();
    setSuggestiveMedList((prevState) => {
      if (prevState) {
        return prevState.filter((item) => item.id !== drug.id);
      }
      return prevState;
    });
  };

  const handleSelAllMed = () => {
    for (let item of suggestiveMedList) {
      saveMedicine(item);
    }
    setSuggestiveMedList([]);
  };
  const [editDrugDetails, setEditDrugDetails] = useState({
    index: "",
    medicineName: "",
    composition: "",
    dosage: "",
    duration: "",
    quantity: "",
    timeTaken: "",
    notes: "",
    frequency: "",
  });
  const showEditModal = (drug, index) => {
    setEditDrugDetails({
      ...drug,
      medicineName: drug.drugName ? drug.drugName : "",
      composition: drug?.composition ? drug?.composition : "",
      dosage: drug.dosage ? drug.dosage : "",
      duration: drug.duration ? drug.duration : "",
      quantity: drug.quantity ? drug.quantity : "",
      timeTaken: drug.afterBeforeFood ? drug.afterBeforeFood : "",
      notes: drug.notes ? drug.notes : "",
      frequency: drug.frequency ? drug.frequency : "",
      index: index,
    });
    setIsModalOpen(true);
  };

  const handleEditChange = (field, value) => {
    setEditDrugDetails((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleEditClear = (field) => {
    setEditDrugDetails((prevState) => ({
      ...prevState,
      [field]: "",
    }));
  };

  const onMedicineEdit = (drugItem) => {
    if (
      editDrugDetails.medicineName == "" &&
      editDrugDetails.composition == ""
    ) {
      message.error("Enter Medicine");
      return;
    }
    let payload = {
      ...editDrugDetails,
      account_Id: appointmentDetails.account_Id,
      clinic_Id: appointmentDetails.clinic_Id,
      afterBeforeFood: editDrugDetails?.timeTaken,
      composition: editDrugDetails.composition,
      createdBy: appointmentDetails.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      dosage: editDrugDetails.dosage,
      drugCode: selectedMed?.code
        ? selectedMed?.code
        : editDrugDetails?.medicineName,
      drugName: editDrugDetails.medicineName,
      duration: editDrugDetails.duration,
      form: null,
      frequency: editDrugDetails.frequency,
      fromDateTime: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      givenDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      instruction: editDrugDetails.notes,
      medicineType: null,
      modifiedBy: appointmentDetails.userId,
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      patientId: appointmentDetails.patientId,
      quantity: editDrugDetails.quantity,
      specialAuthority: null,
      status: 1,
      toDateTime: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      userId: appointmentDetails.userId,
    };

    const updatedArray = [...drugPrescription];
    updatedArray[editDrugDetails.index] = payload;
    setDrugPrescription(updatedArray);
    setEditDrugDetails({
      index: "",
      medicineName: "",
      composition: "",
      dosage: "",
      duration: "",
      quantity: "",
      timeTaken: "",
      notes: "",
      frequency: "",
    });
    setSelectedMed({});
    setFormData({
      medicineName: "",
      composition: "",
      dosage: "",
      duration: "",
      quantity: "",
      timeTaken: "",
      notes: "",
      frequency: "",
    });
    setIsModalOpen(false);
    return;
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setEditDrugDetails({
      index: "",
      medicineName: "",
      composition: "",
      dosage: "",
      duration: "",
      quantity: "",
      timeTaken: "",
      notes: "",
      frequency: "",
    });
    setIsModalOpen(false);
  };

  return (
    <div className="">
      {isModalOpen && (
        <Modal
          title="Edit Medicine"
          closable={{ "aria-label": "Custom Close Button" }}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[]}
          width={1000}
          height={400}
        >
          <div className="flex flex-col">
            <div className="flex  w-full gap-3 p-3">
              <div className="flex flex-col space-y-2 w-[40%] relative mt-2">
                <input
                  value={editDrugDetails.medicineName}
                  onChange={(e) => {
                    handleEditChange("medicineName", e.target.value);
                    onSearchMedicine(e.target.value);
                  }}
                  id="medicineName"
                  type="text"
                  name="Medicine Name"
                  placeholder=""
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] peer  focus:border-[#189FAA] bg-transparent"
                />
                <label
                  htmlFor="medicineName"
                  className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#232323] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
                >
                  Medicine Name
                </label>
                {medicineList.length > 0 && (
                  <ul className="absolute top-10 left-0 w-[80%] mt-1 bg-white border rounded-md shadow-md max-h-20 overflow-y-auto z-10">
                    {medicineList.map((medicine, index) => (
                      <li
                        onClick={() => handleSelectedMedicine(medicine)}
                        key={medicine.id || index}
                        className="px-2 py-1 text-[13px] font-sans hover:bg-gray-200 cursor-pointer"
                      >
                        {medicine.medicineName}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="flex flex-col space-y-2 w-[40%] relative mt-2">
                <input
                  value={editDrugDetails.composition}
                  onChange={(e) =>
                    handleEditChange("composition", e.target.value)
                  }
                  id="composition"
                  type="text"
                  placeholder=""
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323]  peer  focus:border-[#189FAA] bg-transparent"
                />
                <label
                  htmlFor="composition"
                  className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#232323] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
                >
                  Composition
                </label>
              </div>
              <div className="flex flex-col space-y-2 w-[20%]">
                <label
                  htmlFor="Dosage"
                  className="text-sm font-medium font-sans text-[#333333]"
                >
                  {/* Dosage */}
                </label>
                <Select
                  showSearch
                  value={editDrugDetails.dosage || undefined}
                  onChange={(value) => handleEditChange("dosage", value)}
                  onClear={() => handleEditClear("dosage")}
                  allowClear
                  className="w-full text-xs font-medium font-sans text-[#232323]"
                  placeholder="Dosage"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {options.map((option, index) => (
                    <Select.Option key={index} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
                <div className="flex w-[40%]">
                  <Select
                    showSearch
                    onClear={() => handleEditClear("dosage")}
                    allowClear
                    value={editDrugDetails.frequency || undefined}
                    onChange={(value) => handleEditChange("frequency", value)}
                    className="w-full text-xs font-medium font-sans text-[#232323]"
                    placeholder=""
                  >
                    {options2.map((option, index) => (
                      <Select.Option key={index} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              </div>
            </div>
            <div className="flex  w-full gap-3 p-3">
              <div className="flex flex-col space-y-2 w-1/2 relative mt-2">
                <input
                  value={editDrugDetails.duration}
                  onChange={(e) => handleEditChange("duration", e.target.value)}
                  type="text"
                  id="Duration"
                  name="Duration"
                  placeholder="Days"
                  className="placeholder:text-right w-full p-2 border text-start  border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] peer  focus:border-[#189FAA] bg-transparent"
                />
                <label
                  htmlFor="Duration"
                  className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#232323] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
                >
                  Duration
                </label>
              </div>
              <div className="flex flex-col space-y-2 w-1/2 relative mt-2">
                <input
                  value={editDrugDetails.quantity}
                  onChange={(e) => handleEditChange("quantity", e.target.value)}
                  type="text"
                  id="Quantity"
                  name="Quantity"
                  placeholder=""
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] text-start peer  focus:border-[#189FAA] bg-transparent"
                />
                <label
                  htmlFor="Quantity"
                  className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#232323] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
                >
                  Quantity
                </label>
              </div>
              <div className="flex flex-col space-y-2 w-1/2">
                <label
                  htmlFor="To be Taken"
                  className="text-sm font-medium font-sans text-[#333333]"
                >
                  {/* To be Taken */}
                </label>
                <Select
                  value={editDrugDetails.timeTaken || undefined}
                  onChange={(value) => handleEditChange("timeTaken", value)}
                  showSearch
                  onClear={() => handleEditClear("timeTaken")}
                  allowClear
                  className="w-full text-xs font-medium font-sans text-[#232323]"
                  placeholder=" To be Taken"
                >
                  <Select.Option value="AF">After Food</Select.Option>
                  <Select.Option value="BF">Before Food</Select.Option>
                </Select>
              </div>
              <div className="flex flex-col space-y-2 w-1/2 relative mt-2">
                <input
                  value={editDrugDetails.notes}
                  onChange={(e) => handleEditChange("notes", e.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      onMedicineSave(selectedMed);
                    }
                  }}
                  id="Notes"
                  rows="4"
                  placeholder=""
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] text-start peer  focus:border-[#189FAA] bg-transparent"
                />
                <label
                  htmlFor="Notes"
                  className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#232323] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
                >
                  Notes
                </label>
              </div>
              <div className="flex justify-center items-center w-full gap-3 p-3">
                <button
                  className="w-24 h-7 cursor-pointer text-white rounded-md"
                  role="button"
                  onClick={() => onMedicineEdit(selectedMed)}
                  id="updateMedicineBtn"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
      <div
        className="h-[270px] overflow-y-scroll"
        onClick={() => {
          setMedicineList([]);
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            setMedicineList([]);
          }
        }}
      >
        <div className="flex w-full gap-3 p-3">
          <div className="flex flex-col space-y-2 w-[40%] relative mt-2">
            <input
              value={formData.medicineName}
              onChange={(e) => {
                handleChange("medicineName", e.target.value);
                onSearchMedicine(e.target.value);
              }}
              id="medicineName"
              type="text"
              name="Medicine Name"
              placeholder=""
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] peer  focus:border-[#189FAA] bg-transparent"
            />
            <label
              htmlFor="medicineName"
              className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#232323] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
            >
              Medicine Name
            </label>
            {medicineList.length > 0 && (
              <ul className="absolute top-10 left-0 w-[80%] mt-1 bg-white border rounded-md shadow-md max-h-20 overflow-y-auto z-10">
                {medicineList.map((medicine, index) => (
                  <li
                    onClick={() => handleSelectedMedicine(medicine)}
                    key={medicine.id || index}
                    className="px-2 py-1 text-[13px] font-sans hover:bg-gray-200 cursor-pointer"
                  >
                    <span className="flex gap-1 justify-between">
                      <span>{medicine.medicineName}</span>
                      <span title="Fav Medicine">
                        {medicine.isFavourite == "Y" ? <FaRegStar /> : ""}
                      </span>
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="flex flex-col space-y-2 w-[40%] relative mt-2">
            <input
              value={formData.composition}
              onChange={(e) => handleChange("composition", e.target.value)}
              id="composition"
              type="text"
              placeholder=""
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323]  peer  focus:border-[#189FAA] bg-transparent"
            />
            <label
              htmlFor="composition"
              className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#232323] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
            >
              Composition
            </label>
          </div>
          <div className="flex flex-col space-y-2 w-[20%]">
            <label
              htmlFor="Dosage"
              className="text-sm font-medium font-sans text-[#333333]"
            >
              {/* Dosage */}
            </label>

            <Select
              showSearch
              value={formData.dosage || undefined}
              onChange={(value) => handleChange("dosage", value)}
              onClear={() => handleClear("dosage")}
              allowClear
              className="w-full text-xs font-medium font-sans text-[#232323]"
              placeholder="Dosage"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {options.map((option, index) => (
                <Select.Option key={index} value={option}>
                  {option}
                </Select.Option>
              ))}
            </Select>
            <div className="flex w-[40%]">
              <Select
                value={formData.frequency || undefined}
                onChange={(value) => handleChange("frequency", value)}
                className="w-full text-xs font-medium font-sans text-[#232323]"
                placeholder=""
                onClear={() => handleClear("frequency")}
                allowClear
              >
                {options2.map((option, index) => (
                  <Select.Option key={index} value={option}>
                    {option}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        </div>

        <div className="flex justify-center items-center w-full gap-3 p-3">
          <div className="flex flex-col space-y-2 w-1/2 relative mt-2">
            <input
              value={formData.duration}
              onChange={(e) => handleChange("duration", e.target.value)}
              type="text"
              id="Duration"
              name="Duration"
              placeholder="Days"
              className="placeholder:text-right w-full p-2 border text-start  border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] peer  focus:border-[#189FAA] bg-transparent"
            />
            <label
              htmlFor="Duration"
              className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#232323] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
            >
              Duration
            </label>
          </div>
          <div className="flex flex-col space-y-2 w-1/2 relative mt-2">
            <input
              value={formData.quantity}
              onChange={(e) => handleChange("quantity", e.target.value)}
              type="text"
              id="Quantity"
              name="Quantity"
              placeholder=""
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] text-start peer  focus:border-[#189FAA] bg-transparent"
            />
            <label
              htmlFor="Quantity"
              className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#232323] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
            >
              Quantity
            </label>
          </div>
          <div className="flex flex-col space-y-2 w-1/2">
            <label
              htmlFor="To be Taken"
              className="text-sm font-medium font-sans text-[#333333]"
            >
              {/* To be Taken */}
            </label>
            <Select
              value={formData.timeTaken || undefined}
              onChange={(value) => handleChange("timeTaken", value)}
              className="w-full text-xs font-medium font-sans text-[#232323]"
              placeholder=" To be Taken"
              onClear={() => handleClear("timeTaken")}
              allowClear
            >
              <Select.Option value="AF">After Food</Select.Option>
              <Select.Option value="BF">Before Food</Select.Option>
            </Select>
          </div>
          <div className="flex flex-col space-y-2 w-1/2 relative mt-2">
            <input
              value={formData.notes}
              onChange={(e) => handleChange("notes", e.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  onMedicineSave(selectedMed);
                }
              }}
              id="Notes"
              rows="4"
              placeholder=""
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] text-start peer  focus:border-[#189FAA] bg-transparent"
            />
            <label
              htmlFor="Notes"
              className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#232323] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
            >
              Notes
            </label>
          </div>
          <img
            src={Add}
            alt=""
            className="w-7 h-7 mt-2 cursor-pointer"
            role="button"
            onClick={() => onMedicineSave(selectedMed)}
            id="addmedicine"
          />
        </div>
        <div className="flex w-full gap-5 p-3"></div>
        <div className="flex w-full gap-5 p-3"></div>
        <div className="flex flex-col w-full border-gray-300 rounded-lg shadow-md p-3">
          {/* <div className="flex w-full bg-[#F5FEFA] text-[#333333] font-sans font-medium text-xs">
          {[
            "Medicine Name",
            "Composition",
            "Dosage",
            "Duration ",
            "Quantity",
            "To be Taken",
            "Action",
          ].map((header, index) => (
            <div
              key={index}
              className="p-2 border border-[#D2E1E2] text-center w-full"
            >
              {header}
            </div>
          ))}
        </div> */}

          <div className="flex items-center gap-2 flex-wrap">
            {suggestiveMedList &&
              suggestiveMedList?.map((Medicine) => (
                <div
                  className="flex items-center gap-1 cursor-pointer"
                  onClick={() => handleSelectSuggMed(Medicine)}
                >
                  <div className="p-1 rounded-lg bg-brand-primaryColor text-white text-xs flex items-center gap-1">
                    <p className="m-0.5 p-0.5">{Medicine.medicineName}</p>
                    <RxCross2
                      onClick={(e) => handleSuggDelete(e, Medicine)}
                      className="text-xl rounded-[100%] p-1 border border-brand-lightBg"
                    />
                  </div>
                </div>
              ))}
            {suggestiveMedList && suggestiveMedList.length !== 0 && (
              <div
                className="text-sm underline p-1 text-[#189FAA] text-center cursor-pointer"
                onClick={handleSelAllMed}
              >
                Select All
              </div>
            )}
          </div>

          {drugPrescription && drugPrescription.length > 0 && (
            <div className="overflow-x-auto w-full border-gray-300 rounded-lg shadow-md p-3">
              <table className="w-full text-xs font-sans font-medium text-[#333333]">
                <thead className="bg-[#F5FEFA]">
                  <tr>
                    {[
                      "Medicine Name",
                      "Composition",
                      "Dosage",
                      "Duration",
                      "Quantity",
                      "To be Taken",
                      "Notes",
                      "Action",
                    ].map((header, index) => (
                      <th
                        key={index}
                        className="p-2 border border-[#D2E1E2] text-center"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {drugPrescription
                    .filter((drug) => drug?.status !== 0)
                    .map((drug, index) => (
                      <tr
                        key={index}
                        className="text-[#189FAA] bg-white hover:bg-gray-100 text-center"
                      >
                        <td className="p-2 border border-gray-300">
                          {drug?.drugName}
                        </td>
                        <td
                          className="p-2 border border-gray-300 max-w-[200px] truncate "
                          title={drug?.composition}
                        >
                          {drug?.composition?.length > 50
                            ? `${drug.composition.slice(0, 50)}...`
                            : drug?.composition || "-"}
                        </td>
                        <td className="p-2 border border-gray-300">
                          {drug?.dosage ? `${drug.dosage}` : "-"}
                        </td>
                        <td className="p-2 border border-gray-300">
                          {drug?.duration ? `${drug.duration} days` : "-"}
                        </td>
                        <td className="p-2 border border-gray-300">
                          {drug?.quantity || "-"}
                          {drug?.frequency ? `-(${drug?.frequency})` : ""}
                        </td>
                        <td className="p-2 border border-gray-300">
                          {drug?.afterBeforeFood === "AF"
                            ? "After Food"
                            : drug?.afterBeforeFood === "BF"
                              ? "Before Food"
                              : "-"}
                        </td>
                        <td
                          className="p-2 border border-gray-300 max-w-[200px] truncate"
                          title={drug?.instruction}
                        >
                          {drug?.instruction?.length > 50
                            ? `${drug.instruction.slice(0, 50)}...`
                            : drug?.instruction || "-"}
                        </td>
                        <td className="p-2 border border-gray-300">
                          <div className="flex justify-center items-center gap-5">
                            <img
                              src={Edit}
                              alt="Edit"
                              className="w-5 h-5 cursor-pointer"
                              onClick={() => showEditModal(drug, index)}
                            />
                            <img
                              src={Delete}
                              alt="Delete"
                              className="w-5 h-5 cursor-pointer"
                              onClick={() => handleDelete(drug)}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Medicine;
